module.exports = __webpack_public_path__ + "static/media/star-w.a41bbb77.svg";